import React from 'react';

const Notes = ({ notes }) => {
  return (
    <div className="h-full bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200 bg-gray-50">
        <h3 className="text-lg font-medium leading-6 text-gray-900">Notes</h3>
      </div>
      <div className="px-4 py-3 sm:px-6">
        <p className="text-sm text-gray-900 whitespace-pre-line">
          {notes || '-'}
        </p>
      </div>
    </div>
  );
};

export default Notes;
